import axios from "axios"
// export const ROOT_URL = 'http://211.66.86.105:4000';
// export const ROOT_URL = 'http://202.38.254.236:4000';
const ROOT_URL = process.env.PUBLIC_URL;

const httpRequest = axios.create({
  baseURL: ROOT_URL,
});
httpRequest.defaults.headers.common['Cache-Control'] = "no-cache";
httpRequest.defaults.headers.common['Pragma'] = "no-cache";

export default httpRequest